import { useSelector } from 'react-redux';
import {
  isLoggedInSelector,
  isNativeSelector,
} from '../../redux/reducers/app/params';

export const withSEOContent = (Component) => {
  return function Wrapper({ children = null, ...props }) {
    const isNative = useSelector(isNativeSelector);
    const isLoggedIn = useSelector(isLoggedInSelector);

    return isNative || isLoggedIn ? (
      children
    ) : (
      <Component {...props}>{children}</Component>
    );
  };
};
